import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
//Local files
import { ContentContainer, Header, Preview, PreviewContainer, Root, Title, StyledButton } from './Card.styled';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import { representationVariants } from 'helpers/constants';
import { getRepresentation } from 'helpers';

const FillDocCard = ({ id, template: { name ,file} }) => {
  const navigate = useNavigate();

  const handleView = () => navigate(`/fill_templates/${id}`);

  return (
    <Root>
      <PreviewContainer>
        <Preview sx={{ backgroundImage: `url('${getRepresentation(file?.representations, representationVariants.SMALL)}')` }} />
      </PreviewContainer>
      <ContentContainer>
        <Header>
          <Title>{name}</Title>
          <StyledButton onClick={handleView}>View</StyledButton>
        </Header>
      </ContentContainer>
    </Root>
  )
}

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <FillDocCard {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);